import { Directory } from "../../../domain/drawing";
import { FormatReference } from "../../../domain/format";
import { FormatReferenceDirectoryFilterParameter, FormatReferenceFilterParameter } from ".";

export class FormatReferenceTreeFilterParameter {
  constructor(
    private _initializer: (p: FormatReferenceTreeFilterParameter) => void = null,
    public reference: FormatReferenceFilterParameter = new FormatReferenceFilterParameter(),
    public directory: FormatReferenceDirectoryFilterParameter = new FormatReferenceDirectoryFilterParameter(),
  ) {
  }

  filter(source: FormatReference | Directory<string, FormatReference>): boolean {
    if (source instanceof FormatReference) {
      return this.reference.filter(source);
    } else {
      return this.directory.filter(source);
    }
  }

  clear(): void {
    this.reference = new FormatReferenceFilterParameter();
    this.directory = new FormatReferenceDirectoryFilterParameter();
    this.initialize();
  }

  private initialize(): void {
    if (this._initializer) {
      this._initializer(this);
    }
  }

  clone(): FormatReferenceTreeFilterParameter {
    return new FormatReferenceTreeFilterParameter(
      this._initializer,
      this.reference.clone(),
      this.directory.clone(),
    );
  }
}
